import { Request } from 'common/domain/models/request';

const FILTERS = {};
FILTERS[Request.TYPES.VACATION] = false;
FILTERS[Request.TYPES.ABSENCE] = false;
FILTERS[Request.STATUS.REQUESTED] = false;
FILTERS[Request.STATUS.APPROVED] = false;

class CalendarFiltersController {

  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.filters = this.initFilters();
  }

  filterDispatcher() {
    let filters = this.formatFilters(this.filters);
    this.onChangeFilters(this.EventEmitter({ filters: filters }));
  }

  formatFilters(filters) {
    let filterTypes = Object.keys(filters);
    let isActive = (filterType) => {
      return filters[filterType] === true;
    };
    let getName = (filterType) => {
      return filterType;
    };

    return filterTypes
      .filter(isActive)
      .map(getName);
  }

  filterByVacation() {
    this.filters[Request.TYPES.VACATION] = !this.filters[Request.TYPES.VACATION];
    this.filters[Request.TYPES.ABSENCE] = false;

    this.filterDispatcher();
  }

  filterByAbsence() {
    this.filters[Request.TYPES.VACATION] = false;
    this.filters[Request.TYPES.ABSENCE] = !this.filters[Request.TYPES.ABSENCE];

    this.filterDispatcher();
  }

  filterByRequested() {
    this.filters[Request.STATUS.REQUESTED] = !this.filters[Request.STATUS.REQUESTED];
    this.filters[Request.STATUS.APPROVED] = false;

    this.filterDispatcher();
  }

  filterByApproved() {
    this.filters[Request.STATUS.REQUESTED] = false;
    this.filters[Request.STATUS.APPROVED] = !this.filters[Request.STATUS.APPROVED];

    this.filterDispatcher();
  }

  initFilters() {
    return angular.copy(FILTERS);
  }

  cleanFilters() {
    this.filters = this.initFilters();

    this.filterDispatcher();
  }

  hasFilters() {
    return !angular.equals(this.filters, FILTERS);
  }

  getCssActiveVacation() {
    return this.getCssActive(Request.TYPES.VACATION);
  }

  getCssActiveAbsence() {
    return this.getCssActive(Request.TYPES.ABSENCE);
  }

  getCssActiveRequested() {
    return this.getCssActive(Request.STATUS.REQUESTED);
  }

  getCssActiveApproved() {
    return this.getCssActive(Request.STATUS.APPROVED);
  }

  getCssActive(filter) {
    return {
      'active': this.filters[filter] === true
    };
  }

  toggleFilters() {
    this.clicked = !this.clicked;
  }

  showCalendarFilterButtons() {
    if (!this.isMobileApp) {
      return true;
    }

    return this.clicked;
  }
}

export default CalendarFiltersController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarFilters/calendarFilters.controller.js